import { callApiToServer } from "../callApi";

export async function addAdmin(authtoken, adminObject) {
  console.log('calling');
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    console.log('!!!!!!!userObject', adminObject);
    let body = JSON.stringify(adminObject);

    let endUrl = "v1/auth/admin/add-admin";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "POST", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
